import React, { useCallback, useEffect, useMemo, useState } from 'react';

import style from './index.module.scss';
import { getDaysOfMonth } from 'page/MeetingSchedule/utils/timeUtils';
import moment, { Moment } from 'moment';

import CalendarItem from './Calendaritem';
import { useScheduleContext } from 'page/MeetingSchedule/Provider/ScheduleProvider';
import { useResizeCalendar } from './hook/useResizeCalendar';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'model';
import { getMeetingCalendarDetailList } from 'model/meeting';
import { Spin } from 'antd';

interface IProps {
  taskList?: number[];
  noticeList?: number[];
  binkTime?: Moment | undefined;
  onSwitch?: (startTime: number, endTime: number) => void;
  onSelectDate?: (date: number) => void;
}

const ScheduleView: React.FC<IProps> = ({ binkTime }) => {
  const { originState } = useScheduleContext();
  const { calendarMonth } = originState;
  const { width, height, maxCountItem } = useResizeCalendar();
  const calendarList = useSelector((state: RootState) => state.meeting.meetingCalendarDetailList);
  const calendarLoading = useSelector((state: RootState) => state.meeting.meetingCalendarLoading);
  const dispatch = useDispatch();

  // 周
  const weekTitles = useMemo(() => {
    return [...Array(7)].map((_, weekInx) => {
      return moment().day(weekInx);
    });
  }, []);

  // 天
  const days = useMemo(() => {
    return getDaysOfMonth(calendarMonth.year(), calendarMonth.month() + 1);
  }, [calendarMonth]);

  const fetchScheduleList = useCallback(() => {
    const targetDay = getDaysOfMonth(calendarMonth.year(), calendarMonth.month() + 1);
    const beginTime = targetDay[0].valueOf();
    const endTime = targetDay[targetDay.length - 1].add(1, 'day').valueOf();
    dispatch(
      getMeetingCalendarDetailList({
        beginTime,
        endTime
      })
    );
  }, [days]);

  const getMeetingList = (index: number) => {
    if (!!calendarList[index] && Array.isArray(calendarList[index].scheduleList)) {
      return calendarList[index].scheduleList;
    }
    return [];
  };

  useEffect(() => {
    fetchScheduleList();
  }, [fetchScheduleList]);

  useEffect(() => {}, []);

  return (
    <div className={style.warp}>
      <div style={{ width: `${width}%` }} className={style.scheduleWarp}>
        <div className={style.calendar}>
          <div className={style.calendarTitle}>
            {weekTitles.map((title) => {
              return <div className={style.calendarWeek}>{title.format('ddd')}</div>;
            })}
          </div>
          <Spin spinning={calendarLoading}>
            <div style={{ height: `${height}px` }} className={style.calendarContent}>
              {days.map((day, index) => {
                return (
                  <div style={{ height: `${height / 6}px` }} className={style.calendarDay}>
                    <CalendarItem
                      meetingList={getMeetingList(index)}
                      maxNumberPayload={maxCountItem}
                      itemTime={day}
                      key={day.valueOf()}
                      binkTime={binkTime}
                      index={index}
                    ></CalendarItem>
                  </div>
                );
              })}
            </div>
          </Spin>
        </div>
      </div>
    </div>
  );
};
export default ScheduleView;
